export default "https://0f174046-a3c4-46d7-88af-9cfef9e6bcb2.selcdn.net/webpack/production/594cffe03755fea620da47eb85b0ef4d.jpg";